import { WireIsoService } from '@treasury/domain/wires';

angular.module('backOffice').service('wireIsoService', WireIsoService);
